import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-gray-200 mt-8 mb-4 w-[445px] -mx-6" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-base leading-6 font-medium text-black py-4" }, "If above criteria are met, go here:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-700" }, "Branch name", -1)
const _hoisted_4 = { class: "flex items-center justify-center border border-gray-300 shadow-sm h-[42px] rounded-l-md rounded-r-md focus-within:border-primary-color-500 focus-within:ring-1 focus-within:ring-primary-color-500" }
const _hoisted_5 = { class: "handle py-2.5 px-3.5 bg-gray-50 rounded-l-md cursor-move" }
const _hoisted_6 = ["onUpdate:modelValue", "placeholder", "onKeypress"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-gray-200 mt-8 mb-4 w-[445px] -mx-6" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-base leading-6 font-medium text-black py-4" }, "If none of the criteria are met, go here:", -1)

import { ref, nextTick, onMounted, watch } from "vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import FilterRule from "@/components/filters/FilterRule.vue"
import FilterList from "@/components/filters/FilterList.vue"
import AttributeList from "@/components/filters/AttributeList.vue"
import { PlusIcon } from "@heroicons/vue/solid"
import { TrashIcon } from "@heroicons/vue/outline"
import DragVertical from "@/components/icons/DragVertical.vue"
import { useGridCollectionStore } from "@/stores/grid-collection"
import { useWorkflowStore } from "@/stores/workflow"
import { Attribute } from "@/shared/models/attributes"
import { Filter } from "@/shared/models/filter"


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiplePropertiesComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()
const gridCollectionStore = useGridCollectionStore()

const formChoiceOptions = ref()
const isEditFilter = ref(false)

function addNewOption() {
    workflowStore.branches.push({ value: "" })

    // focus the newly added input
    nextTick(() => {
        focusLastInput()
    })
    if (workflowStore.branches[0].filtersGroups?.length) {
        workflowStore.areButtonDisabled = false
    }
}

function focusLastInput() {
    const inputs = formChoiceOptions.value?.targetDomElement?.querySelectorAll("input")
    if (!inputs?.length) {
        return
    }
    inputs[inputs.length - 1].focus()
}

function deleteOption(index: number) {
    if (workflowStore.branches.length === 1) {
        return
    }
    workflowStore.branches = workflowStore.branches.filter((_, i) => i !== index)
}

function isCurrentFilterStep(step: string) {
    return workflowStore.branches[0]?.currentStep === step
}
function selectAttribute(attribute: Attribute) {
    workflowStore.branches[0].selectedFilter = {
        field: attribute.name,
        type: attribute.type,
        displayName: attribute.displayName,
    }
    workflowStore.branches[0].currentStep = "filterRule"
    isEditFilter.value = false
}

function applyFilter(filter: Filter) {
    if (["body"].includes(filter.field)) {
        filter.field = `messages.${filter.field}`
    }

    isEditFilter.value ? editFilterGroup(filter) : addFilterToGroup(filter)
    openFiltersList()

    workflowStore.areButtonDisabled = false
}

function editFilterGroup(filter: Filter) {
    if (filter.field === "phones") {
        filter.field = "phones.number"
    } else if (filter.field === "emails") {
        filter.field = "emails.emailAddress"
    }
    const branch = workflowStore.branches[0]
    workflowStore.branches.at(0).filtersGroups[branch.selectedFilterGroup].filters[branch.selectedFilterIndex] = filter
}

function addFilterToGroup(filter: Filter) {
    // TODO - we need to discuss about object type
    if (filter.field === "phones") {
        filter.field = "phones.number"
    } else if (filter.field === "emails") {
        filter.field = "emails.emailAddress"
    }
    const branch = workflowStore.branches[0]
    if (!branch) {
        return
    }
    if (!branch?.filtersGroups?.at(branch.selectedFilterGroup!)) {
        workflowStore.branches.at(0)?.filtersGroups?.push({ filters: [filter] })
        return
    }

    workflowStore.branches.at(0)?.filtersGroups?.at(branch.selectedFilterGroup!)?.filters.push(filter)
}

function openAttributeList() {
    workflowStore.branches[0].currentStep = "attributeList"
}

function openFiltersList() {
    workflowStore.branches[0].currentStep = "filterList"
}

function editFilter(filter: Filter, filterIndex: number) {
    workflowStore.branches[0].selectedFilter = {
        field: filter.field,
        type: filter.type,
        rule: filter.rule,
        value: filter.value,
        displayName: filter.displayName,
    }
    isEditFilter.value = true
    workflowStore.branches[0].currentStep = "filterRule"
    workflowStore.branches[0].selectedFilterIndex = filterIndex
}

async function clearFilters() {
    workflowStore.branches[0].currentStep = undefined
    workflowStore.branches[0].selectedFilter = {
        field: "",
        type: "",
        rule: "",
        value: "",
        displayName: "",
    }
    if (!workflowStore.branches.length) {
        workflowStore.areButtonDisabled = true
    }
}

function cancelFilter() {
    resetSelectedFilter()
    openFiltersList()
}

function resetSelectedFilter() {
    workflowStore.branches[0].selectedFilter = {
        field: "",
        type: "",
        rule: "",
        value: "",
    }
}
watch(
    () => workflowStore.noneBranch.value,
    () => (workflowStore.areButtonDisabled = false)
)

watch(
    () => workflowStore.branches,
    () => (workflowStore.areButtonDisabled = false),
    { deep: true }
)
onMounted(() => {
    gridCollectionStore.getPrototypesByPage("contacts")
})

return (_ctx: any,_cache: any) => {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isCurrentFilterStep('attributeList'))
      ? (_openBlock(), _createBlock(AttributeList, {
          key: 0,
          class: "mt-6",
          onOnAttributeSelect: selectAttribute
        }))
      : _createCommentVNode("", true),
    (isCurrentFilterStep('filterRule'))
      ? (_openBlock(), _createBlock(FilterRule, {
          key: 1,
          class: "mt-6",
          filter: _unref(workflowStore).branches[0]?.selectedFilter!,
          isUpdated: isEditFilter.value,
          onApplyFilter: applyFilter,
          onCancel: cancelFilter
        }, null, 8, ["filter", "isUpdated"]))
      : _createCommentVNode("", true),
    (isCurrentFilterStep('filterList'))
      ? (_openBlock(), _createBlock(FilterList, {
          key: 2,
          savedFiltersGroups: _unref(workflowStore).branches[0].filtersGroups,
          isWorkflow: true,
          onAddNewFilter: openAttributeList,
          onEditFilter: editFilter,
          onClearFilters: clearFilters
        }, null, 8, ["savedFiltersGroups"]))
      : _createCommentVNode("", true),
    (!_unref(workflowStore).branches[0]?.currentStep)
      ? (_openBlock(), _createBlock(GgmsButton, {
          key: 3,
          class: "mt-6",
          onClick: openAttributeList
        }, {
          default: _withCtx(() => [
            _createTextVNode("Add filters "),
            _createVNode(_unref(PlusIcon), { class: "w-4 h-4 ml-2" })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_draggable, {
      ref_key: "formChoiceOptions",
      ref: formChoiceOptions,
      list: _unref(workflowStore).branches,
      "item-key": "id",
      handle: ".handle",
      class: "flex flex-col gap-y-2 mb-2 mt-1"
    }, {
      item: _withCtx(({ element, index }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(DragVertical, { class: "h-5 w-5 stroke-gray-400" })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((element.value) = $event),
            type: "text",
            placeholder: `Branch ${index + 1}`,
            class: "w-full border-gray-300 focus:border-primary-color-500 focus:border-l-gray-300 focus:border-r-gray-300 focus:ring-transparent",
            onKeypress: _withKeys(_withModifiers(addNewOption, ["prevent"]), ["enter"])
          }, null, 40, _hoisted_6), [
            [_vModelText, element.value]
          ]),
          _createElementVNode("div", {
            class: "py-2 px-3.5 bg-gray-50 rounded-r-md cursor-pointer",
            onClick: ($event: any) => (deleteOption(index))
          }, [
            _createVNode(_unref(TrashIcon), { class: "h-6 w-6 stroke-gray-400" })
          ], 8, _hoisted_7)
        ])
      ]),
      _: 1
    }, 8, ["list"]),
    _createVNode(GgmsButton, {
      styleType: "simple",
      "icon-start": _unref(PlusIcon),
      class: "w-fit",
      classes: ['py-0 px-0 pr-2 text-primary-color-600'],
      "icon-classes": ['fill-primary-color-600'],
      onClick: addNewOption
    }, {
      default: _withCtx(() => [
        _createTextVNode("Add Branch")
      ]),
      _: 1
    }, 8, ["icon-start"]),
    _hoisted_8,
    _hoisted_9,
    _createVNode(GgmsInput, {
      modelValue: _unref(workflowStore).noneBranch.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).noneBranch.value) = $event)),
      label: "‘Not met’ branch name",
      placeholder: "Conditions not met"
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})